module.exports = __webpack_public_path__ + "static/media/A6-Landscape-H1.c7c370ac.png";